import { useState } from "react";
import { getQueryParams } from "src/_utils/urls";
import EBSSSTable from "src/base/atoms/EBSSSTable";
import { useEBSSSLayout } from "src/base/context/EBSSSLayoutContext/useEBSSSLayout";
import useEditSearchParams from "src/base/hooks/useEditSearchParams";
import TablePage from "src/base/TablePage";

const ReservationsPage = () => {
  const { trans } = useEBSSSLayout();
  const [page, setPage] = useState(1);
  const [ordering, setOrdering] = useState(null);
  const { searchParams, updateQueryParams } = useEditSearchParams();

  return (
    <TablePage title="" description="" breads={[{ name: trans("website.reservations"), active: false }]}>
      <EBSSSTable
        pageHandler={setPage}
        data={[]}
        cols={[]}
        sortFunc={(table: string) => {
          setOrdering(getQueryParams(window.location.href)?.ordering === "asc" ? "desc" : "asc");
          updateQueryParams({
            ...searchParams,
            ordering: ordering?.ordering === "asc" ? "desc" : "asc",
            ordering_column: table,
          });

          return 1;
        }}
      />
    </TablePage>
  );
};

export default ReservationsPage;
